// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./VoyahFreeSpec.css";

// const API_BASE = process.env.REACT_APP_API_BASE_URL;

// const VoyahFreeSpec = () => {
//   const [sections, setSections] = useState([]);
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggle = (i) => {
//     setOpenIndex((prev) => (prev === i ? null : i));
//   };

//   // ============================================
//   // LOAD DATA FROM BACKEND
//   // ============================================
//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(`${API_BASE}/api/VoyahFreeSpec?lang=en`);
//         setSections(res.data);
//       } catch (err) {
//         console.error("Error loading FreeSpec:", err);
//       }
//     };

//     load();
//   }, []);

//   const resolveUrl = (url) =>
//     url?.startsWith("http") ? url : `${API_BASE}${url}`;

//   return (
//     <section className="vf-spec">

//       {/* TITLE */}
//       <h1 className="vf-title">All the information you need</h1>

//       {/* NOTE */}
//       <p className="vf-small-note">S = Standard equipment at no extra cost</p>

//       {/* TABS */}
//       <div className="vf-tabsSpecial">
//         <div className="vf-tabP">2WD</div>
//         <div className="vf-tabP">4WD</div>
//       </div>

//       {/* ACCORDION */}
//       <div className="accordion" id="vfAccordion">
//         {sections.map((section, index) => (
//           <div className="accordion-item vf-item" key={section.id}>

//             {/* HEADER */}
//             <h2 className="accordion-header">
//               <button
//                 className={`accordion-button vf-header ${
//                   openIndex === index ? "" : "collapsed"
//                 }`}
//                 type="button"
//                 onClick={() => toggle(index)}
//                 data-bs-toggle="collapse"
//                 data-bs-target={`#collapse-${index}`}
//               >
//                 {section.title}
//               </button>
//             </h2>

//             {/* BODY */}
//             <div
//               id={`collapse-${index}`}
//               className={`accordion-collapse collapse ${
//                 openIndex === index ? "show" : ""
//               }`}
//               data-bs-parent="#vfAccordion"
//             >
//               <div className="accordion-body p-0">

//                 {/* TABLE SECTION */}
//                 {section.type === "table" && (
//                   <table className="vf-table">
//                     <tbody>
//                       {section.rows.map((row) => (
//                         <tr key={row.id}>
//                           <td className="label">{row.label}</td>
//                           <td className="value">{row.value}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}

//                 {/* IMAGES SECTION */}
//                 {section.type === "images" && (
//                   <div className="vf-image-grid">
//                     {section.images.map((img) => (
//                       <div className="vf-image-card" key={img.id}>
//                         <div className="vf-image-wrapper">
//                           <img
//                             src={resolveUrl(img.imageUrl)}
//                             alt={img.label}
//                           />
//                         </div>
//                         <p className="vf-img-label">{img.label}</p>
//                       </div>
//                     ))}
//                   </div>
//                 )}

//               </div>
//             </div>

//           </div>
//         ))}
//       </div>

//       {/* FOOTNOTE */}
//       <p className="vf-note">
//         All specifications on this website are indicative and subject to change without notice.
//       </p>
//     </section>
//   );
// };

// export default VoyahFreeSpec;


import React, { useState } from "react";
import "./VoyahFreeSpec.css";



const VoyahFreeSpec = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };


  const sections = [
    {
      id: 1,
      title: "Dimensions",
      type: "table",
      rows: [
        { id: 1, label: "Length", value: "4,905 mm" },
        { id: 2, label: "Width", value: "1,950 mm" },
        { id: 3, label: "Height", value: "1,640 mm" }
      ]
    },
    {
      id: 2,
      title: "Performance",
      type: "table",
      rows: [
        { id: 1, label: "Power", value: "489 HP" },
        { id: 2, label: "Top Speed", value: "200 km/h" },
        { id: 3, label: "0–100 km/h", value: "4.5 s" }
      ]
    },
    {
      id: 3,
      title: "Available Colors",
      type: "images",
      images: [
        { id: 1, label: "Ice White", imageUrl: "../../" },
        { id: 2, label: "Deep Blue", imageUrl: "/images/spec/blue.webp" }
      ]
    }
  ];

  return (
    <section className="vf-spec">
      {/* TITLE */}
      <h1 className="vf-title">All the information you need</h1>

      {/* NOTE */}
      <p className="vf-small-note">S = Standard equipment at no extra cost</p>

      {/* TABS */}
      <div className="vf-tabsSpecial">
        <div className="vf-tabP">2WD</div>
        <div className="vf-tabP">4WD</div>
      </div>

      {/* ACCORDION */}
      <div className="accordion" id="vfAccordion">
        {sections.map((section, index) => (
          <div className="accordion-item vf-item" key={section.id}>

            {/* HEADER */}
            <h2 className="accordion-header">
              <button
                className={`accordion-button vf-header ${
                  openIndex === index ? "" : "collapsed"
                }`}
                onClick={() => toggle(index)}
              >
                {section.title}
              </button>
            </h2>

            {/* BODY */}
            <div
              className={`accordion-collapse collapse ${
                openIndex === index ? "show" : ""
              }`}
            >
              <div className="accordion-body p-0">
                
                {/* TABLE SECTION */}
                {section.type === "table" && (
                  <table className="vf-table">
                    <tbody>
                      {section.rows.map((row) => (
                        <tr key={row.id}>
                          <td className="label">{row.label}</td>
                          <td className="value">{row.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {/* IMAGES SECTION */}
                {section.type === "images" && (
                  <div className="vf-image-grid">
                    {section.images.map((img) => (
                      <div className="vf-image-card" key={img.id}>
                        <div className="vf-image-wrapper">
                          <img src={img.imageUrl} alt={img.label} />
                        </div>
                        <p className="vf-img-label">{img.label}</p>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>
          </div>
        ))}
      </div>

      {/* FOOTNOTE */}
      <p className="vf-note">
        All specifications on this website are indicative and subject to change without notice.
      </p>
    </section>
  );
};

export default VoyahFreeSpec;
